import { render, staticRenderFns } from "./myBill.vue?vue&type=template&id=bcfff202&scoped=true"
import script from "./myBill.vue?vue&type=script&lang=js"
export * from "./myBill.vue?vue&type=script&lang=js"
import style0 from "./myBill.vue?vue&type=style&index=0&id=bcfff202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfff202",
  null
  
)

export default component.exports